import React from "react";

export const ToolBarItem = (props) => (
    <div className={"c-toolBar__item"}>
        {props.children}
    </div>
);
